import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-posted-lca',
  templateUrl: './view-posted-lca.component.html',
  styleUrls: ['./view-posted-lca.component.scss']
})
export class ViewPostedLcaComponent implements OnInit {
  htmlTemplate: string = ``;

  constructor(
    public dialogRef: MatDialogRef<ViewPostedLcaComponent>,
    @Inject(MAT_DIALOG_DATA) public lcaData,
    private clipboard: Clipboard,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.htmlTemplate = this.lcaData.buttonSnippet;
  }
  onDismiss() {
    this.dialogRef.close(false);
  }
  copyUrl() {
    this.clipboard.copy(this.lcaData.postedLcaURL);
    this.toastr.success('URL copied to clipboard', 'Success');
  }

}
